export var raRealTimeLanguageEnglish = {
    'ra-realtime': {
        notification: {
            title: 'Warning',
            record: {
                updated: 'This record has been updated by another user',
                deleted: 'This record has been deleted and is no longer available',
            },
        },
    },
};
export default raRealTimeLanguageEnglish;
